import { useEffect } from "react";

import { UseQueryOptions, useSuspenseQuery } from "@tanstack/react-query";

import { useGetPatentListFilterData } from "@/components/business/PatentContainer/hooks/useGetPatentFilterData";
import { queryClient } from "@api/queryClient";
import { usePatentListFilterState } from "@stores/patentList";

import { patentListApis } from "./patent.service";
import { PATENT_QUERY_KEYS } from "../queryKey";

import type {
  PatentFilteringData,
  PostPatentListFilterResponse,
} from "@interface/patentList.interface";

export const usePatentListFilterQuery = (
  options?: UseQueryOptions<
    PostPatentListFilterResponse,
    unknown,
    PostPatentListFilterResponse,
    [string, PatentFilteringData]
  >,
) => {
  const filteringData = useGetPatentListFilterData();

  const [, setPatentListFilter] = usePatentListFilterState();
  const query = useSuspenseQuery({
    queryKey: [
      PATENT_QUERY_KEYS.patentListFilter,
      filteringData as PatentFilteringData,
    ],
    queryFn: async () =>
      patentListApis.post(filteringData as PatentFilteringData),
    staleTime: 0,
    refetchInterval: 2000,
    ...options,
  });

  useEffect(() => {
    setPatentListFilter((prev) => ({
      ...prev,
      maxPage: query.data.totalPages,
      patentListDataTotal: query.data.total,
    }));
  }, [query.data.totalPages, query.data.total, setPatentListFilter]);

  return query;
};

export const invalidatePatentTableDataQuery = () => {
  return queryClient.invalidateQueries({
    queryKey: [PATENT_QUERY_KEYS.patentListFilter],
  });
};
